<div [class]="record.type + ' ' + (record.currentComponent.deliveryPath.code)">
  <div [id]="'bulkEditCheckHeader_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
       [class]="record.type + ' ' + (record.currentComponent.deliveryPath.code)">
    <span style="float: right">
      <span style="margin: 0 0.5em 0 0.5em;"
            [id]="'productLine_'  + record.type + '_' + (record.currentComponent.productLine) + '_' + index"
            [class]="'badge-label product-line-label ' + (record.currentComponent.productLine)"
            [innerHTML]="record.currentComponent.productLine"></span>
      <span style="margin: 0 0.5em 0 0.5em;"
            [id]="'deliveryPath_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
            [class]="'badge-label delivery-path-label ' + (record.currentComponent.deliveryPath.code)"
            [innerHTML]="record.currentComponent.deliveryPath.code"></span>
      </span>
    <h3 [id]="'recordTitle_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index">
      {{record.type}} #{{index + 1}}: {{record.currentComponent.displayLabel}} ({{record.currentComponent.name}})
    </h3>
    <hr/>
  </div>
  <div [id]="'bulkEditCheckBody_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
       [class]="'panel-body ' + record.type + ' ' + (record.currentComponent.deliveryPath.code)">

    <div class="row" *ngIf="record.isObsoleteOldContent()">
      <p class="bg-warning padding-sm round-border">
        <i class="fas fa-exclamation-triangle fa-lg" style="color: #FF9900"></i>&nbsp;<strong>Warning:</strong> the content in
        the database has changed since you downloaded the file you are now uploading. Verify you are not overwriting
        changes to content you wish to keep before finalizing the upload OR download a fresh file, make your desired
        changes, and then upload.</p>
        <p class="bg-warning padding-sm round-border">
          <i class="fas fa-exclamation-triangle fa-lg" style="color: #FF9900"></i>&nbsp;<strong>Warning:</strong> All single quotes will be always change to double quotes.</p>
    </div>

    <!-- Display selector -->
    <div class="td-toolbar-select-format" *ngIf="showToolbar && showBtnToolbar">
      <div class="td-btn-group td-btn-group-toggle" data-toggle="buttons">
        <button
          *ngFor="let option of formatOptions"
          [ngClass]="{ active: format === option.value, disabled: !!option.disabled }"
          [name]="option.name"
          [id]="option.id"
          [disabled]="!!option.disabled"
          (click)="setDiffTableFormat(option.value)"
        >
          {{ option.label }}
        </button>
      </div>
    </div>

    <!-- Side-by-side display -->
    <div class="row padding-bottom-lg" *ngIf="format === 'SideBySide'">
      <table class="w-100">
        <tbody>
        <tr>
          <td class="padding-bottom-sm padding-top-sm col-md-6 vl">
            <div class="container-fluid">
              <div
                [id]="'currentText_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
                class="row" [innerHTML]="transformHTMLText(record.currentContent.content)"></div>
            </div>
          </td>
          <td class=" col-md-6">
            <div class="container-fluid">
              <div [id]="'newText_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
                   class="row" [innerHTML]="transformHTMLText(record.newContent.content)"></div>
            </div>
          </td>
        </tr>
        <tr>
          <td class=" col-md-6">
            <div class="container-fluid">
            <span style="float: right; margin: 0 0.5em 0 0.5em;"
                  [id]="'currentLocale_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
                  [class]="'badge-label locale-label ' + (record.currentContent.locale)"
                  [innerHTML]="record.currentContent.locale"
                  [tooltip]="getLocaleTooltip(record.currentContent.locale)"></span>
              <span style="float: right; margin: 0 0.5em 0 0.5em;"
                    [id]="'currentProgram_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
                    [class]="'badge-label product-label ' + (record.currentContent.productId || 'DEFAULT')"
                    [innerHTML]="getProductDisplayLabel(record.currentContent.productId)"
                    [tooltip]="getOperatorProgramProductTooltip(record.currentContent.productId)"></span>
            </div>
          </td>
          <td class=" col-md-6">
            <div class="container-fluid">
              <span style="float: right; margin: 0 0.5em 0 0.5em;"
                    [id]="'newLocale_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
                    [class]="'badge-label locale-label ' + (record.newContent.locale)"
                    [innerHTML]="record.newContent.locale"
                    [tooltip]="getLocaleTooltip(record.newContent.locale)"></span>
              <span style="float: right; margin: 0 0.5em 0 0.5em;"
                    [id]="'newProgram_'  + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
                    [class]="'badge-label product-label ' + (record.newContent.productId || 'DEFAULT')"
                    [innerHTML]="getProductDisplayLabel(record.newContent.productId)"
                    [tooltip]="getOperatorProgramProductTooltip(record.newContent.productId)"></span>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Line-by-line display -->
    <div class="row" *ngIf="format === 'LineByLine'">
      <td-ngx-text-diff
        [id]="'textDiff_' + record.type + '_' + (record.currentComponent.deliveryPath.code) + '_' + index"
        [left]="record.currentContent.content"
        [right]="record.newContent.content"
        [showBtnToolbar]="true"
        outerContainerClass="NgxDiffOuterContainer"
        toolbarClass="NgxDiffToolbar"
        compareRowsClass="NgxDiffCompareRows"
        [loading]="true"></td-ngx-text-diff>
    </div>
  </div>
</div>
